import moment from 'moment';

export const fakeUser = {
    id: 30,
    firstName: 'John',
    lastName: 'Smith',
    dateOfBirth: moment("1982-10-12", "YYYY-MM-DD"),
    medicareNumber: 123456, 
}

export const fakeLabResults = [
    {
        type: 'Covid19',
        result: false,
        date: moment("2020-03-25T12:00:00Z", moment.ISO_8601),
    },
    {
        type: 'Covid19',
        result: true,
        date: moment("2020-03-22T11:00:00Z", moment.ISO_8601),
    }
]

export const fakeResponse = {
    success:true,
    message:"",
    error:{},
    data:{
        patientResults:{
            id:"11111",
            firstName:"Jane",
            lastName:"Doe",
            dateOfBirth:"1938-11-20T00:00:00Z",
            hcn:"123456789",
            accessLevel:"2",
            email:"jane.doe@hotmail.com",
            results:[
                {
                    resultStatus: "F",
                    resultCode: "POSITIVE",
                    mnemonic: "PCRNCOV",
                    collectionDate:"2020-03-23T00:00:00Z",
                    resultDate:"2020-03-23T00:12:00Z",
                    result:"Positive",
                    resultType: "covid-19"
                },{
                    resultStatus: "F",
                    mnemonic: "PCRNCOV",
                    resultCode: "NEGATIVE",
                    collectionDate:"2020-03-18T00:00:00Z",
                    resultDate:"2020-03-18T00:12:00Z",
                    result:"Negative",
                    resultType: "covid-19"
                }, {
                    resultStatus: "F",
                    resultCode: "POSITIVE",
                    mnemonic: "PCRNCOV",
                    collectionDate:"2020-02-12T00:00:00Z",
                    resultDate:"2020-03-30T00:12:00Z",
                    result:"Awaiting Result",
                    resultType: "covid-19"
                }, {
                    resultStatus: "F",
                    resultCode: "EQUIVOCAL",
                    mnemonic: "PCRNCOV",
                    collectionDate:"2020-02-05T00:00:00Z",
                    resultDate:"2020-04-03T00:12:00Z",
                    result:"Equivocal",
                    resultType: "covid-19"
                }
            ]
        }
    },
    responseId:"4ea19b20-1d04-4075-9030-150eac62cb3a",
    responseTimestamp:"2020-03-27T15:12:49.893969344Z"
}

export const fakeResponseDependents = {
    success:true,
    message:"",
    error:{},
    data:{
        patientResults:{
            id:"11112",
            firstName:"Charles",
            lastName:"Doe",
            dateOfBirth:"1988-11-20T00:00:00Z",
            hcn:"123456789",
            accessLevel:"2",
            email:"charles.doe@gmail.com",
            results:[
                {
                    resultStatus: "F",
                    resultCode: "POSITIVE",
                    mnemonic: "PCRNCOV",
                    collectionDate:"2020-03-23T00:00:00Z",
                    resultDate:"2020-03-23T00:12:00Z",
                    result:"Positive",
                    resultType: "covid-19"
                },{
                    resultStatus: "F",
                    mnemonic: "PCRNCOV",
                    resultCode: "NEGATIVE",
                    collectionDate:"2020-03-18T00:00:00Z",
                    resultDate:"2020-03-18T00:12:00Z",
                    result:"Negative",
                    resultType: "covid-19"
                }, {
                    resultStatus: "F",
                    resultCode: "POSITIVE",
                    mnemonic: "PCRNCOV",
                    collectionDate:"2020-02-12T00:00:00Z",
                    resultDate:"2020-03-30T00:12:00Z",
                    result:"Awaiting Result",
                    resultType: "covid-19"
                }, {
                    resultStatus: "F",
                    resultCode: "EQUIVOCAL",
                    mnemonic: "PCRNCOV",
                    collectionDate:"2020-02-05T00:00:00Z",
                    resultDate:"2020-04-03T00:12:00Z",
                    result:"Equivocal",
                    resultType: "covid-19"
                }
            ],
            dependents:[
                {
                    id:"11113",
                    patientResults:{
                        firstName:"Jim",
                        lastName:"Doe",
                        dateOfBirth:"2015-11-20T00:00:00Z",
                        hcn:"123456789",
                        results:[
                            {
                                resultStatus: "F",
                                resultCode: "POSITIVE",
                                mnemonic: "PCRNCOV",
                                collectionDate:"2020-03-23T00:00:00Z",
                                resultDate:"2020-03-23T00:12:00Z",
                                result:"Positive",
                                resultType: "covid-19"
                            },{
                                resultStatus: "F",
                                mnemonic: "PCRNCOV",
                                resultCode: "NEGATIVE",
                                collectionDate:"2020-10-18T00:00:00Z",
                                resultDate:"2020-10-18T00:12:00Z",
                                result:"Negative",
                                resultType: "covid-19"
                            },
                        ]
                    }
                },
                {
                    id:"11114",
                    patientResults:{
                        firstName:"James",
                        lastName:"Doe",
                        dateOfBirth:"2009-01-12T00:00:00Z",
                        hcn:"123456788",
                        results:[
                            {
                                resultStatus: "F",
                                mnemonic: "PCRNCOV",
                                resultCode: "NEGATIVE",
                                collectionDate:"2020-03-18T00:00:00Z",
                                resultDate:"2020-03-18T00:12:00Z",
                                result:"Negative",
                                resultType: "covid-19"
                            }, {
                                resultStatus: "F",
                                resultCode: "NEGATIVE",
                                mnemonic: "PCRNCOV",
                                collectionDate:"2020-02-12T00:00:00Z",
                                resultDate:"2020-03-30T00:12:00Z",
                                result:"Negative",
                                resultType: "covid-19"
                            }, {
                                resultStatus: "F",
                                resultCode: "NEGATIVE",
                                mnemonic: "PCRNCOV",
                                collectionDate:"2020-02-05T00:00:00Z",
                                resultDate:"2020-04-03T00:12:00Z",
                                result:"Negative",
                                resultType: "covid-19"
                            },
                        ]
                    }
                },
                {
                    id:"11115",
                    patientResults:{
                        firstName:"Jay",
                        lastName:"Doe",
                        dateOfBirth:"2004-04-12T00:00:00Z",
                        hcn:"123456788",
                        results:[
                            {
                                resultStatus: "F",
                                mnemonic: "PCRNCOV",
                                resultCode: "NEGATIVE",
                                collectionDate:"2020-03-18T00:00:00Z",
                                resultDate:"2020-03-18T00:12:00Z",
                                result:"Negative",
                                resultType: "covid-19"
                            }
                        ]
                    }
                }
            ]
        }
    },
    responseId:"4ea19b20-1d04-4075-9030-150eac62cb3a",
    responseTimestamp:"2020-03-27T15:12:49.893969344Z"
}

// This immunization data is missing Immunization Status (valid/invalid)
export const fakeImmunizationResult = {
    success: true,
    message: "",
    error: {},
    data: {
        patientImmunization: {
            firstName: "Jane",
            lastName: "Doe",
            dateOfBirth: "1938-11-20",
            hcn: "123456789",
            hcnIssuer: "NB",
            immunizations: [
                {
                    "doseNumber": "1",
                    "vaccinationDate": "2030-12-31",
                    "tradeName": "COVID-19 Pfizer-BioNTech mRNA-ARNm BTM",
                    "agentName": "COVID-19 mRNA",
                    "lotNumber": "PFIZCOV-123",
                    "dosage": "0.3",
                    "dosageUOM": "mL",
                    "site": "Right arm",
                    "route": "Intramuscular: IM",
                    "serviceLocation": "Moncton High School",
                    "serviceProvider": "Vinubhai Patel",
                },
                {
                    "doseNumber": "2",
                    "vaccinationDate": "2030-12-31",
                    "tradeName": "COVID-19 Pfizer-BioNTech mRNA-ARNm BTM",
                    "agentName": "COVID-19 mRNA",
                    "lotNumber": "PFIZCOV-123",
                    "dosage": "0.3",
                    "dosageUOM": "mL",
                    "site": "Right arm",
                    "route": "Infiltrate",
                    "serviceLocation": "Miramichi Rural School",
                    "serviceProvider": "Brett Jackson",
                },
                {
                    "doseNumber": "3",
                    "vaccinationDate": "2021-07-01",
                    "tradeName": "COVID-19 Pfizer-BioNTech mRNA-ARNm BTM",
                    "agentName": "COVID-19 mRNA",
                }
            ]
        }
    },
    "responseId": "8f0cbc22-0e86-4386-81b4-199a51c4bd5c",
    "responseTimestamp": "2021-07-23T14:30:08.791354429Z"
}

// GET DEPENDENT FROM DEV
export const fakeDependent2 = {
    "success": true,
    "message": "",
    "error": {},
    "data": {
        "demographics": [
            {
                "firstName": "KATARA",
                "lastName": "PICKETT-FERNANDEZ",
                "hcn": "111069811",
                "hcnIssuer": "NB",
                "dateOfBirth": "2018-02-09",
                "userInfoId": "819a979f-2689-4f6f-8762-67650c6a35d4",
                "vsfUserId": "625a116b-c9b7-48f0-a1de-80757647d75d"
            },
            {
                "firstName": "BUBBLES",
                "lastName": "PAGE",
                "hcn": "662559896",
                "hcnIssuer": "NB",
                "dateOfBirth": "2017-06-20",
                "userInfoId": "6453b115-455a-4d18-870d-209a712bc945",
                "vsfUserId": "c2c2d7a2-22a2-4266-934c-c648540b8e07"
            }
        ]
    },
    "responseId": "185930e7-3400-40b7-ac9f-b9623352f83b",
    "responseTimestamp": "2021-07-23T14:41:11.644667775Z"
}

// GET 


export const fakeJwt = "eyJhbGciOiJSUzI1NiIsImtpZCI6IjhzX2JGX2o3bl90OWRqV2VhSmVGaklhYklBdyJ9.eyJzdWIiOiJQYWlnZS5TaW5jbGFpckB5b3BtYWlsLmNvbSIsImF1ZCI6ImNvdmlkIiwianRpIjoicklqOE9rM3VEUUo1WWlmTldpZEtMTCIsImlzcyI6Imh0dHBzOi8vYWNjZXNzLXNpdC5pZC5nbmIuY2EiLCJpYXQiOjE1ODY1MjYxNDIsImV4cCI6MTU4NjUyNzM0MiwiYXV0aF90aW1lIjoxNTg2NTI2MTQyLCJmaXJzdE5hbWUiOiJQYWlnZSIsImxhc3ROYW1lIjoic2luY2xhaXIiLCJoY24iOiI3MjM3MDQ0OTAiLCJtYWlsIjoiUGFpZ2UuU2luY2xhaXJAeW9wbWFpbC5jb20iLCJjclNvdXJjZUlEIjoiMDc0NTY3OTY3IiwiZG9iIjoiMTkyNy0xMi0yOCIsInBvc3RhbENvZGUiOiJFN04gN0gzIiwiaGNuSXNzdWVyIjoiTkIiLCJuYW1lIjoiUGFpZ2Ugc2luY2xhaXIiLCJwcmVmZXJyZWRMYW5nIjoiZW4iLCJoY25FeHBpcnkiOiIwMi8yMDIzIiwibm9uY2UiOiJRMDlqUW5rdlZFYyJ9.WnCbmr6CnI8f7LeuDmDausrDzm-0vNQEgoQneA-pSWIW4Wq7B4MeRvjpehvqsmNeV5Fs0kn2jRlMQgvalLXK6B5OBUC_AIQOxCylOawsFVkW2p9tcW8AXqwXdlgpGnwHnCTc_RE_JV2-wUbN3b0jcOy7M0QjmF8aJYVQVpb_-4x2mUY-aGZlcZcj1QRkxjVoce3TfVKj3fehFrOcWVm0R8jFQC2VdIMIznc3gWLLW8gET3N2MyptpO2ktmsFh0SGZq511_zL0Flm0MB4YRgicRQzsvuK3QMh1AAZ3SgzL-IkoYVovtSvLFOvAewpDYToCrzSmr--2WehvmoZ3ba7wA";
export const fakeJwtFR = "eyJhbGciOiJSUzI1NiIsImtpZCI6IjhzX2JGX2o3bl90OWRqV2VhSmVGaklhYklBdyJ9.eyJzdWIiOiJBZGVsaW5hLk11bGxlbkB5b3BtYWlsLmNvbSIsImF1ZCI6ImNvdmlkIiwianRpIjoiYTFnRmVNazNOUDhqMms4NlJVNjNoSyIsImlzcyI6Imh0dHBzOi8vYWNjZXNzLXNpdC5pZC5nbmIuY2EiLCJpYXQiOjE1ODY1MjUzMTQsImV4cCI6MTU4NjUyNjUxNCwiYXV0aF90aW1lIjoxNTg2NTI1MzE0LCJmaXJzdE5hbWUiOiJBZGVsaW5hIiwibGFzdE5hbWUiOiJNdWxsZW4iLCJoY24iOiI3MzMzMjA3NTgiLCJtYWlsIjoiQWRlbGluYS5NdWxsZW5AeW9wbWFpbC5jb20iLCJjclNvdXJjZUlEIjoiODA1NDIwODc0IiwiZG9iIjoiMTk3Ny0xMi0wOCIsInBvc3RhbENvZGUiOiJFNFMgOU4yIiwiaGNuSXNzdWVyIjoiTkIiLCJuYW1lIjoiQWRlbGluYSBNdWxsZW4iLCJwcmVmZXJyZWRMYW5nIjoiZnIiLCJoY25FeHBpcnkiOiIxMS8yMDIwIiwibm9uY2UiOiJWVmhqVERSWVlXMCJ9.RGjFVdYSwqVpmiFjFLKG-oGM3vF_kZbOKVJJiL9T7N1Rob-L6u8_9QxPl1kT6V7UehPlZa3iVjX4TToYI22P9_ZbqjJUreI5Hr_00VRwiTXxfSYxJX_UI5DFFEH7uic6gUjTJS1Bhpq3Gatpnq1q0soPKYRkNqNOTNvwP09-uQ_47cTaOYK3iLN7aTzWu2HQa5wUCq5TfnvXlfwAvGrEaQbPnsgyIY4_9d1wbqsNShMjKeSBfxDEedgeCsNFXliOmf0MlZ32PveiSMTiAHhG51LhMMDiULZaZL3ICy9GschNKEOTsLHD09Ipv_40YrN4SaB0Q_VE1GacM2hK6WGy_g";
export const fakeBadJwt = "eyJhbGciOiJSUzNiIsImtpZCI6IjhzX2JGX2o3bl90OWRqV2VhSmVGaklhYklBdyJ9.eyJzdWIWlnZS5TaW5jbGFpckB5b3BtYWlsLmNvbSIsImF1ZCI6ImNvdmlkIiwianRpIjoicklqOE9rM3VEUUo1WWlmTldpZEtMTCIsImlzcyI6Imh0dHBzOi8vYWNjZXNzLXNpdC5pZC5nbmIuY2EiLCJpYXQiOjE1ODY1MjYxNDIsImV4cCI6MTU4NjUyNzM0MiwiYXV0aF90aW1lIjoxNTg2NTI2MTQyLCJmaXJzdE5hbWUiOiJQYWlnZSIsImxhc3ROYW1lIjoic2luY2xhaXIiLCJoY24iOiI3MjM3MDQ0OTAiLCJtYWlsIjoiUGFpZ2UuU2luY2xhaXJAeW9wbWFpbC5jb20iLCJjclNvdXJjZUlEIjoiMDc0NTY3OTY3IiwiZG9iIjoiMTkyNy0xMi0yOCIsInBvc3RhbENvZGUiOiJFN04gN0gzIiwiaGNuSXNzdWVyIjoiTkIiLCJuYW1lIjoiUGFpZ2Ugc2luY2xhaXIiLCJwcmVmZXJyZWRMYW5nIjoiZW4iLCJoY25FeHBpcnkiOiIwMi8yMDIzIiwibm9uY2UiOiJRMDlqUW5rdlZFYyJ9.WnCbmr6CnI8f7LeuDmDausrDzm-0vNQEgoQneA-pSWIW4Wq7B4MeRvjpehvqsmNeV5Fs0kn2jRlMQgvalLXK6B5OBUC_AIQOxCylOawsFVkW2p9tcW8AXqwXdlgpGnwHnCTc_RE_JV2-wUbN3b0jcOy7M0QjmF8aJYVQVpb_-4x2mUY-aGZlcZcj1QRkxjVoce3TfVKj3fehFrOcWVm0R8jFQC2VdIMIznc3gWLLW8gET3N2MyptpO2ktmsFh0SGZq511_zL0Flm0MB4YRgicRQzsvuK3QMh1AAZ3SgzL-IkoYVovtSvLFOvAewpDYToCrzSmr--2WehvmoZ3ba7wA";
